import React, { useState } from "react";
import HouseForm from "../components/houses/HouseForm";
import AuthService from "../services/authService";
import HouseEdit from "../components/houses/HouseEdit";

const Dashboard = () => {
  const [option, setOption] = useState("add");
  const auth = AuthService();
  const user = auth.getCurrentUser();

  const handleMenuClick = (type) => {
    setOption(type);
  };
  return (
    <div>
      <div>
        <nav className=" dashboard-nav">
          <div class="dashboard-nav--welcome">
            <p>Welcome! {user}</p>
          </div>
          <div class="dashboard-nav--buttons">
            <button
              onClick={() => handleMenuClick("add")}
              className="dashboard-nav__anadir"
            >
              Añadir
            </button>
            <button
              onClick={() => handleMenuClick("edit")}
              className="dashboard-nav__editar"
            >
              Editar
            </button>
            <button
              onClick={() => auth.logout()}
              className="btn-submit dashboard-nav__logout"
            >
              Log out
            </button>
          </div>
        </nav>
      </div>
      {option === "add" && <HouseForm action={"new"} />}
      {option === "edit" && <HouseEdit />}
    </div>
  );
};

export default Dashboard;
